import React from 'react';
import { ReactSelectStyles, SelectorFilterOptions } from './SelectorUtils';
import CreatableSelect from 'react-select/creatable';
import _ from 'lodash';

export interface MultipleSelectItem {
  label: string;
  value: string;
  metadata?: any;
}

interface Props {
  items: MultipleSelectItem[];
  selected: MultipleSelectItem[] | MultipleSelectItem;
  onChange: (selected: MultipleSelectItem[] | MultipleSelectItem) => void;
  readonly?: boolean;
  placeholder?: string;
  noOptionsMessage?: string;
  isMulti?: boolean;
}

/**
 * Multiple select component based on React Selector.
 * @constructor
 */
const MultipleSelect = ({ items, selected, onChange, readonly, placeholder, noOptionsMessage, isMulti }: Props) => {
  const onChangeHandler = (items: any) => {
    onChange(items);
  };

  return (
    <div className={'react-tag-selector'}>
      <CreatableSelect
        isDisabled={readonly}
        styles={ReactSelectStyles}
        inputId="react-select-multiple"
        TextFieldProps={{
          label: 'Tags',
          InputLabelProps: {
            htmlFor: 'react-select-multiple',
            shrink: true,
          },
        }}
        isValidNewOption={() => false} //Disables creation
        placeholder={placeholder ? placeholder : 'Define Tags'}
        options={items}
        value={selected}
        onChange={onChangeHandler}
        isMulti={isMulti}
        isSearchable
        filterOption={SelectorFilterOptions}
        noOptionsMessage={() => {
          return noOptionsMessage ? noOptionsMessage : 'No Options';
        }}
      />
    </div>
  );
};

export default MultipleSelect;
